import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getActiveDirectoryAuthToken } from "utils/getActiveDirectoryAuthToken";
import { v4 as uuidv4 } from "uuid";

import { withMeteredScheduling } from "./meteredRequestQueue";

import config from "../../config";

// The plain request sender for the user service.
const rawBaseQuery = fetchBaseQuery({
  // Set the base URL for the userServiceApi.
  baseUrl: `${typeof config === "string" ? config : config.user}/api`,
  // Prepare headers function is used to set the headers for each request to the userServiceApi.
  prepareHeaders: async (headers, { getState, endpoint }) => {
    // Set the Content-Type header to "application/json" for all endpoints except "updateUserOrgStatusBatchWithExcel" which will be auto set by the browser.
    if (endpoint !== "updateUserOrgStatusBatchWithExcel") {
      headers.set("Content-Type", "application/json");
    }

    headers.set("x-correlation-id", uuidv4());

    // Fetch fresh authToken from Active Directory and append it to the headers. (Handles token refresh if expired.)
    const authToken = await getActiveDirectoryAuthToken();
    headers.set("Authorization", `Bearer ${authToken}`);
    return headers;
  },
});

// Base RTK Query API setup for user service API calls.
export const userServiceApiSlice = createApi({
  reducerPath: "userServiceApi",
  // Metered Usage requests are sent a couple at a time, quick ones first, with a quiet retry on a gateway timeout (see
  // meteredRequestQueue.js). Every other request goes straight through.
  baseQuery: withMeteredScheduling(rawBaseQuery),
  // Tag types are used to group endpoints together in the Redux store. Metered Usage queries carry "MeteredUsage" (reload
  // everything) plus "MeteredUsageLight" or "MeteredUsageHeavy", so the slow reports can be reloaded less often.
  tagTypes: ["User", "UserTrackers", "MeteredUsage", "MeteredUsageLight", "MeteredUsageHeavy", "SyncSchedule"],
  endpoints: (builder) => ({}),
});
